import { RenderPass } from '@seddi/three/examples/jsm/postprocessing/RenderPass.js';

export class ThreeMainRenderPass extends RenderPass {
  constructor(scene) {
    super(scene);
  }

  render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */) {
    renderer.applyDepthPeeling = true;

    super.render(renderer, writeBuffer, readBuffer);

    renderer.applyDepthPeeling = false;
  }
}
